module.exports = __webpack_public_path__ + "img/casepic4.f723dba8.png";